export const CLIP_BOARD_COPY = "API/UI/CLIP_BOARD/COPY";
export const CLIP_BOARD_CLEAR = "API/UI/CLIP_BOARD/CLEAR";
